<template>
  <div class="myhome-bookmarks" :class="{ 'myhome-bookmarks--expanded': isDropdownOpen }">
    <div class="grid grid--wide">
      <h2 v-if="!user.parent" class="xs-12 myhome-bookmarks__title dea-heading--medium__l">
        I miei preferiti - ultimi elementi salvati
      </h2>
      <h2 v-else class="xs-12 myhome-bookmarks__title dea-heading--medium__l">
        I miei articoli Dlive preferiti
      </h2>
      <div v-if="sortedBookmarks.length" class="xs-12 dea-card-resource-container dea-card-resource-container--home">
        <div class="grid">
          <CardBookmark
            v-for="(bookmark, index) in sortedBookmarks.slice(0, 4)"
            :key="bookmark.id"
            class="xs-12 s-6 m-4"
            :bookmark="bookmark"
            :accent-modifier="user.targetTitle.toLowerCase()"
            :action-accent-modifier="user.targetTitle.toLowerCase()"
            @delete-bookmark="deleteBookmark"
            @dropdown-toggled="checkDropdowns(index)"
          />

          <div v-if="sortedBookmarks.length > 4" class="event-panel__link">
            <router-link
              class="dea-links dea-links--align-right dea-links--no-border dea-links--decoration"
              :class="`dea-links--decoration-${user.targetCss.colorMod}`"
              :to="{ name: 'bookmarks-resources' }"
            >
              <span class="dea-links__label dea-heading--medium-l"> Vai all'elenco completo </span>
              <span class="icon dea-links__icon dea-ico-go-to" aria-label="icona vai a"></span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <EmptyBookmarks v-if="!sortedBookmarks.length" :link-color="user.targetCss.colorMod" :parent="user.parent" />
  </div>
</template>

<script>
import ResourceClient from "dea-bookmarks-clients/src/clients/resources";
import EmptyBookmarks from "~/components/books/components/EmptyBookmarks";
import CardBookmark from "~/components/bookmarks/components/CardBookmark";
import BookmarkActions from "~/components/bookmarks/mixins/BookmarkActions";

export default {
  name: "HomeBookmarks",
  components: { EmptyBookmarks, CardBookmark },
  mixins: [BookmarkActions],
  props: {
    bookmarks: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isDropdownOpen: false,
    };
  },
  computed: {
    sortedBookmarks() {
      return JSON.parse(JSON.stringify(this.bookmarks)).sort(
        (first, second) => Date(first.created_at) <= Date(second.created_at)
      );
    },
    token() {
      if (this.$cookies) return this.$cookies.get("deatoken");
      return null;
    },
  },
  methods: {
    deleteBookmark(bookmark) {
      if (this.token) {
        ResourceClient.deleteObject(this.token, bookmark.id).then(() => {
          this.$set(this.bookmarks, bookmark.data_obj_id, null);
          const attribute = ResourceClient.getAttributeByType(bookmark.type);
          // this event is used by upper components using vuex to keep the state consistent (if needed)
          this.removeBookmark(attribute, bookmark);
        });
      }
    },
    checkDropdowns(index) {
      this.$nextTick(() => {
        const bookmarkCards = Array.from(document.querySelectorAll(".myhome-bookmarks .dea-card-resource--compact"));
        const selectedCard = bookmarkCards[index];
        const selectedButton = selectedCard.querySelector(".dea-buttons-share");
        this.isDropdownOpen =
          selectedButton && window.getComputedStyle(selectedButton).getPropertyValue("display") === "block";
        this.$nextTick(() => {
          if (this.isDropdownOpen) selectedButton.scrollIntoView({ behavior: "smooth", block: "start", inline: "end" });
        });
      });
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.myhome-bookmarks {
  &__title {
    margin: 0 0 $space-small;
  }

  &--expanded {
    margin-bottom: 220px;
  }
}

.dea-card-resource-container--home {
  @include media("<=m") {
    flex-wrap: wrap;
  }
  flex-wrap: nowrap;

  .event-panel__link {
    @include hpadding($space-xm-small, $space-xm-small);
    @include media("<=l") {
      width: 33%;
    }
    @include media("<=m") {
      margin: $space-small $space-xm-small;
      order: -1;
      width: 100%;
    }

    margin-top: $space-base;

    width: 20%;
  }
}

.dea-card-resource-container--home {
  .dea-card-resource--compact {
    @include media("<=l") {
      width: 25%;
    }
    @include media("<=m") {
      width: 33%;
    }
    @include media("<=s") {
      width: 50%;
    }
    @include media("<=xs") {
      width: 100%;
    }

    max-width: unset;
    width: 20%;
  }
}
</style>
